import { isWithinMinutes } from './dateUtils'

export function getHotelStatus(lastPing) {
  if (!lastPing) return 'disconnected'
  
  if (isWithinMinutes(lastPing, 3)) {
    return 'connected'
  } else if (isWithinMinutes(lastPing, 10)) {
    return 'warning'
  } else {
    return 'disconnected'
  }
}

export function getStatusColor(status) {
  switch (status) {
    case 'connected':
      return 'status-connected'
    case 'warning':
      return 'status-warning'
    case 'disconnected':
      return 'status-disconnected'
    default:
      return 'status-disconnected'
  }
}

export function getStatusText(status) {
  switch (status) {
    case 'connected':
      return 'Connected'
    case 'warning':
      return 'Warning'
    case 'disconnected':
      return 'Disconnected'
    default:
      return 'Unknown'
  }
}

export function getStatusBadgeClass(status) {
  switch (status) {
    case 'connected':
      return 'bg-green-100 text-green-800'
    case 'warning':
      return 'bg-yellow-100 text-yellow-800'
    case 'disconnected':
      return 'bg-red-100 text-red-800'
    default:
      return 'bg-gray-100 text-gray-800'
  }
}

export function getSuccessRateColor(rate) {
  if (rate >= 95) return 'text-green-600'
  if (rate >= 80) return 'text-yellow-600'
  return 'text-red-600'
}

export function getResponseTimeColor(time) {
  if (time <= 1000) return 'text-green-600'
  if (time <= 3000) return 'text-yellow-600'
  return 'text-red-600'
}